'use client';

import { useNativePush } from '@oxpa/shared/hooks/use-native-push';

export function NativePluginsProvider({ children }: { children: React.ReactNode }) {
  // Инициализируем пуш-уведомления при маунте клиентского приложения
  useNativePush();

  // В будущем здесь можно добавить другие глобальные плагины
  
  return <>{children}</>;
}
